{
  "selectAsField": "Выбрать \"{value}\" в качестве {fieldName}",
  "typeToSearchField": "Введите для поиска {fieldName}",
  "licenseFieldLabel": "Выбрать номерной знак (напр. 215BG2)",
  "licenseFieldName": "Номерной знак",
  "licensePlaceholder": "Поиск по номерному знаку",
  "dotFieldLabel": "Выбрать номер DOT",
  "dotFieldName": "Номер DOT",
  "dotPlaceholder": "Поиск по номеру DOT",
  "chooseOneOption": "Выберите один из вариантов ниже"
}
